import {
  FETCH_SIZES_REQUEST,
  FETCH_SIZES_SUCCESS,
  FETCH_SIZES_FAILURE,
  ADD_SIZE_REQUEST,
  ADD_SIZE_SUCCESS,
  ADD_SIZE_FAILURE,
  UPDATE_SIZE_REQUEST,
  UPDATE_SIZE_SUCCESS,
  UPDATE_SIZE_FAILURE,
  DELETE_SIZE_REQUEST,
  DELETE_SIZE_SUCCESS,
  DELETE_SIZE_FAILURE,
  SET_SIZE_EDIT,
  CLEAR_SIZE_EDIT,
} from '../../../../types/masters/styles/size/sizeTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingSize: null,
};

const sizeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SIZES_REQUEST:
    case ADD_SIZE_REQUEST:
    case UPDATE_SIZE_REQUEST:
    case DELETE_SIZE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SIZES_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_SIZE_SUCCESS:
    case UPDATE_SIZE_SUCCESS:
    case DELETE_SIZE_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_SIZES_FAILURE:
    case ADD_SIZE_FAILURE:
    case UPDATE_SIZE_FAILURE:
    case DELETE_SIZE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_SIZE_EDIT:
      return { ...state, editingSize: action.payload };
    case CLEAR_SIZE_EDIT:
      return { ...state, editingSize: null };
    default:
      return state;
  }
};

export default sizeReducer; 